import { isHtmlElement } from './isHtmlElement';

export const scrollTo = (element: any): void => {
  if (isHtmlElement(element)) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};
